import { render, staticRenderFns } from "./BookDestination.vue?vue&type=template&id=79e46915&"
import script from "./BookDestination.vue?vue&type=script&lang=js&"
export * from "./BookDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports